// Backup na nuvem — Supabase Storage bucket "Backups"
// Camada durável complementar ao localStorage: sobrevive troca de navegador/máquina
import { supabase } from '../lib/supabase';

const BUCKET = 'Backups';
const LIMITE_NUVEM = 500; // rotação — remove os mais antigos acima disso (~1 GB free)

function nomeArquivo(geradoEm) {
  const iso = new Date(geradoEm).toISOString().replace(/[:.]/g, '-').replace('T', '_').slice(0, 19);
  return `snapshot_${iso}.json`;
}

// Faz upload de um snapshot para o bucket. Silencioso em falha.
export async function uploadSnapshotNuvem(snapshot) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return { ok: false, motivo: 'sem sessão' };
    const payload = {
      versao: '2.0',
      geradoEm: snapshot.geradoEm,
      tipo: snapshot.tipo,
      totalRegistros: snapshot.totalRegistros,
      usuario: session.user.email,
      dados: snapshot.dados,
    };
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    const path = nomeArquivo(snapshot.geradoEm);
    const { error } = await supabase.storage.from(BUCKET).upload(path, blob, {
      contentType: 'application/json',
      upsert: true,
    });
    if (error) return { ok: false, motivo: error.message };
    return { ok: true, path };
  } catch (e) {
    return { ok: false, motivo: e?.message || 'erro desconhecido' };
  }
}

// Lista os snapshots do bucket (mais recentes primeiro)
export async function listarSnapshotsNuvem() {
  try {
    const { data, error } = await supabase.storage.from(BUCKET).list('', {
      limit: 1000,
      sortBy: { column: 'created_at', order: 'desc' },
    });
    if (error) return [];
    return (data || [])
      .filter(f => f.name?.startsWith('snapshot_') && f.name.endsWith('.json'))
      .map(f => ({
        path: f.name,
        id: f.id,
        criadoEm: f.created_at,
        tamanho: f.metadata?.size || 0,
      }));
  } catch {
    return [];
  }
}

// Baixa e parseia um snapshot do bucket
export async function baixarSnapshotNuvem(path) {
  const { data, error } = await supabase.storage.from(BUCKET).download(path);
  if (error) throw error;
  const texto = await data.text();
  return JSON.parse(texto);
}

// Remove um snapshot do bucket
export async function excluirSnapshotNuvem(path) {
  const { error } = await supabase.storage.from(BUCKET).remove([path]);
  if (error) throw error;
}

// Remove snapshots mais antigos que o limite (rotação automática)
export async function rotacionarNuvem(limite = LIMITE_NUVEM) {
  const lista = await listarSnapshotsNuvem();
  if (lista.length <= limite) return 0;
  const excedentes = lista.slice(limite).map(s => s.path);
  if (excedentes.length === 0) return 0;
  const { error } = await supabase.storage.from(BUCKET).remove(excedentes);
  if (error) return 0;
  return excedentes.length;
}
